import React from 'react';
import { config } from '@keytrade/functions';

const { list: colors } = config.colors;

const TikTokIcon: React.FC = () => {
  return (
    <svg
      width='22'
      height='23'
      viewBox='0 0 22 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-label='TikTok'
    >
      <path
        d='M8.68946 10.9583C6.96208 10.9583 5.56177 12.3586 5.56177 14.086C5.56177 15.8133 6.96208 17.2137 8.68946 17.2137C10.4168 17.2137 11.8171 15.8133 11.8171 14.086V5.7863C12.3003 7.86265 13.695 9.30897 15.9936 9.30897'
        stroke={colors.BlueDawn}
        strokeWidth='1.55895'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.28621 16.6362C1.52842 18.9002 3.34924 20.721 5.61203 20.9732C7.29275 21.1605 9.01843 21.3214 10.7778 21.3214C12.5373 21.3214 14.2629 21.1605 15.9436 20.9732C18.2065 20.721 20.0273 18.9002 20.2694 16.6362C20.4483 14.965 20.5993 13.2492 20.5993 11.5C20.5993 9.75075 20.4483 8.03497 20.2694 6.36374C20.0273 4.09986 18.2065 2.27903 15.9436 2.02682C14.2629 1.83948 12.5373 1.67857 10.7778 1.67857C9.01843 1.67857 7.29275 1.83948 5.61203 2.02682C3.34924 2.27903 1.52842 4.09986 1.28621 6.36374C1.10741 8.03497 0.956421 9.75075 0.956421 11.5C0.956421 13.2492 1.10741 14.965 1.28621 16.6362Z'
        stroke={colors.BlueDawn}
        strokeWidth='1.55895'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TikTokIcon;
